import type { ReactNode } from "react";

import PixelField from "./PixelField";

interface Props {
  /** Синий — главное действие или живой момент; чёрный — итог и выбор. */
  tone: "blue" | "black";
  seed?: number;
  eyebrow?: ReactNode;
  /** Крупная цифра: тоннаж, длительность, 1ПМ. */
  value?: ReactNode;
  /** Крупное слово, когда цифры нет. */
  title?: ReactNode;
  caption?: ReactNode;
  onClick?: () => void;
}

/**
 * Брендовый блок, как карточки референса: матрица сверху, крупное снизу.
 *
 * Нажимаемый — кнопка, иначе блок: роль элемента должна совпадать с тем, что
 * он делает, а не только с тем, как выглядит.
 */
export default function BrandBlock({ tone, seed = 1, eyebrow, value, title, caption, onClick }: Props) {
  const content = (
    <>
      <PixelField className="brand__field" seed={seed} />
      {eyebrow && <span className="brand__eyebrow">{eyebrow}</span>}
      {value !== undefined && <span className="brand__value">{value}</span>}
      {title && <span className="brand__title">{title}</span>}
      {caption && <span className="brand__caption">{caption}</span>}
    </>
  );

  return onClick ? (
    <button className={`brand brand--${tone} brand--tap`} onClick={onClick}>
      {content}
    </button>
  ) : (
    <div className={`brand brand--${tone}`}>{content}</div>
  );
}
